import script from "./password-strength.vue?vue&type=script&setup=true&lang=js"
export * from "./password-strength.vue?vue&type=script&setup=true&lang=js"

import "./password-strength.vue?vue&type=style&index=0&id=4e0f1c53&lang=scss"

const __exports__ = script;

export default __exports__